import { render, staticRenderFns } from "./userStastic.vue?vue&type=template&id=138f4101&scoped=true&"
import script from "./userStastic.vue?vue&type=script&lang=js&"
export * from "./userStastic.vue?vue&type=script&lang=js&"
import style0 from "./userStastic.vue?vue&type=style&index=0&id=138f4101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f4101",
  null
  
)

export default component.exports